var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sui-segment',{staticClass:"instruction"},[_c('sui-label',{attrs:{"attached":"top"}},[_vm._v(_vm._s(_vm.title))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.message)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }